import rentmanagerLogo from '@/asset/images/rentmanager-logo.svg';
import leadsimpleLogo from '@/asset/images/leadsimple-logo.svg';

export interface ComingSoonVendor {
  name: string;
  logo: string;
  /** Rendered wordmark height on the coming-soon tile (prototype value). */
  logoHeightPx: number;
  description: string;
}

/** Vendors shown as "Coming Soon" on the Integrations landing (spec §4.5). Not in vendorRegistry: they have no settings page. */
export const comingSoonVendors: readonly ComingSoonVendor[] = [
  {
    name: 'Rent Manager',
    logo: rentmanagerLogo,
    logoHeightPx: 24,
    description:
      'A 2-way sync that integrates your properties with PlanOmatic for easy ordering and delivers your photos directly to Rent Manager.',
  },
  {
    name: 'Lead Simple',
    logo: leadsimpleLogo,
    logoHeightPx: 20,
    description:
      'Connect your property marketing process with PlanOmatic to automate your step to order photography.',
  },
];
